<script setup lang="ts">
import { computed } from "vue";
import { NSpace, NIcon } from "naive-ui";
import { $t } from "@/locales";

interface Props {
    currentTier: string;
    userTierNumber: number;
    isMobile: boolean;
    direction: "ltr" | "rtl";
    showUpgrade: boolean;
}

const props = defineProps<Props>();

const emit = defineEmits<{
    openModal: [];
}>();

const userTier = computed(() => {
    const tierMapping: Record<string, string> = {
        zero: $t("limits.noAccess"),
        tier0: `${$t("limits.tier")} ${$t("limits.free")}`,
        tier1: `${$t("limits.tier")} 1`,
        tier2: `${$t("limits.tier")} 2`,
        tier3: `${$t("limits.tier")} 3`,
        tier4: `${$t("limits.tier")} 4`,
        tier5: `${$t("limits.tier")} 5`,
    };

    return tierMapping[props.currentTier] || $t("limits.noAccess");
});

const tierTypeColor = computed(() => {
    if (props.currentTier === "zero") return "red";
    if (props.currentTier === "tier0") return "orange";
    if (["tier1", "tier2"].includes(props.currentTier)) return "#00a5f4"; //sky "#00a5f4"
    if (["tier3", "tier4"].includes(props.currentTier)) return "#00bd7c"; //emerald
    if (props.currentTier === "tier5") return "gold";
    return "red";
});

const handleOpenModal = () => {
    emit("openModal");
};
</script>

<template>
    <div class="flex items-center" :class="[props.direction]">
        <NSpace :size="8" align="center">
            <NButton round ghost :size="isMobile ? 'tiny' : 'small'" @click="handleOpenModal"
                :icon-placement="props.direction === 'rtl' ? 'right' : 'left'">
                <template #icon>
                    <NIcon v-if="props.showUpgrade" size="18" :style="{
                        marginRight: direction === 'rtl' ? '12px' : '0',
                    }">
                        <ArrowUpIcon />
                    </NIcon>
                    <NIcon v-else size="18" :color="tierTypeColor" :style="{
                        marginRight: direction === 'rtl' ? '12px' : '0',
                    }">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                            <path fill="currentColor"
                                d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                        </svg>
                    </NIcon>
                </template>
                <div>
                    <span v-if="props.showUpgrade">
                        {{ $t("limits.upgradeNow") }}
                    </span>
                    <span v-else>
                        {{ userTier }}
                    </span>

                </div>

            </NButton>
        </NSpace>
    </div>
</template>
